import { Injectable } from '@angular/core';

@Injectable()
export class DateService {
  constructor() {}

  public DateToString(date: Date, format: string):string {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    var hh = String(date.getHours()).padStart(2, '0');
    var minute = String(date.getMinutes()).padStart(2, '0');
    var second = String(date.getSeconds()).padStart(2, '0');

    if (format == 'yyyy-mm-dd') {
      return yyyy + '-' + mm + '-' + dd;
    } else if (format == 'yyyy-mm') {
      return yyyy + '-' + mm;
    } else if (format == 'yyyy/mm/dd') {
      return yyyy + '/' + mm + '/' + dd;
    } else if (format == 'yyyy年mm月dd日') {
      return yyyy + '年' + mm + '月' + dd + '日';
    } else if (format == 'hh:mm') {
      return hh + ':' + minute;
    } else if (format == 'hh:mm:ss') {
      return hh + ':' + minute + ':' + second;
    }else{
      return "parseError";
    }
  }
  public StringToDate(dateStr:string) {
    var date = new Date(dateStr);

    if (isNaN(date.getTime())) {
      date = new Date(dateStr.replace(/ /g, 'T'));
    }

    return date;
  }
  public GetToday(dateFormat = 'yyyy-mm-dd') {
    var today = new Date();

    return this.DateToString(today, dateFormat);
  }
  public GetNowTime() {
    var today = new Date();

    return this.DateToString(today, 'hh:mm');
  }
  public AddDays(dateStr: string, addDays: number) {
    var date = this.StringToDate(dateStr);
    date.setDate(date.getDate() + addDays);

    return this.DateToString(date, 'yyyy-mm-dd');
  }
  public AddMinutes(hhmm: string, addMinutes: number): string {
    var hour = hhmm.substring(0, 2);
    var minute = hhmm.substring(3, 5);

    var rawMinute = addMinutes + Number(minute);
    var addHours = Math.floor(rawMinute / 60);
    var lastMinute = rawMinute % 60;

    return (
      String(Number(hour) + addHours).padStart(2, '0') +
      ':' +
      String(lastMinute).padStart(2, '0')
    );
  }
  public SubtractMinutes(hhmm: string, subtractMinutes: number): string {
    const hour = parseInt(hhmm.substring(0, 2), 10);
    const minute = parseInt(hhmm.substring(3, 5), 10);

    let rawMinute = minute - subtractMinutes; // 減去分鐘
    let newHour = hour;

    // 處理分鐘不足導致的跨小時
    while (rawMinute < 0) {
        rawMinute += 60; // 補足一小時的分鐘
        newHour -= 1; // 小時減一
    }

    // 處理小時不足導致的跨午夜
    while (newHour < 0) {
        newHour += 24; // 回繞到上一天的最後一小時
    }

    return (
        String(newHour).padStart(2, '0') + ':' + String(rawMinute).padStart(2, '0')
    );
  }
  public MinuteDiff(timeFrom: string, timeTo: string): number {
    var hourFrom = Number(timeFrom.substring(0, 2));
    var hourTo = Number(timeTo.substring(0, 2));
    var minuteFrom = Number(timeFrom.substring(3, 5));
    var minuteTo = Number(timeTo.substring(3, 5));

    return (hourTo - hourFrom) * 60 + (minuteTo - minuteFrom);
  }
  public HourDiff(timeFrom: string, timeTo: string): number {
    var hourFrom = Number(timeFrom.substring(0, 2));
    var hourTo = Number(timeTo.substring(0, 2));
    var minuteFrom = Number(timeFrom.substring(3, 5));
    var minuteTo = Number(timeTo.substring(3, 5));

    return hourTo - hourFrom + (minuteTo - minuteFrom) / 60;
  }
}
